import React from 'react';
import moment from 'moment';

// export const formFields = {
//   parentTenantId: {
//     key: 'parentTenantId',
//     label: 'Tenant',
//     required: true,
//     placeholder: '',
//     requiredMessage: 'This field is required.',
//     displayLayout: 'col-md-7',
//     tooltip: '<div> Tenant Name </div>',
//     valueKey: 'id',
//     textKey: 'text',
//   },
//   accountName: {
//     key: 'accountName',
//     label: 'Account Name',
//     placeholder: '',
//     required: true,
//     requiredMessage: 'This field is required.',
//     displayLayout: 'col-md-12',
//     tooltip: '<div> Account Name </div>',
//     // maxLength: 7,
//     // maxLengthMessage: 'maximum 7 characters allowed.',
//   },
//   accountType: {
//     key: 'accountType',
//     label: 'Account Type',
//     placeholder: '',
//     required: true,
//     requiredMessage: 'This field is required.',
//     displayLayout: 'col-md-12',
//     tooltip: '<div> Account Type </div>',
//     valueKey: 'key',
//     textKey: 'value',
//     // maxLength: 7,
//     // maxLengthMessage: 'maximum 7 characters allowed.',
//   },  accTenantId: {
//     key: 'accTenantId',
//     label: 'Account ID',
//     placeholder: '',
//     required: true,
//     requiredMessage: 'This field is required.',
//     displayLayout: 'col-md-12',
//     tooltip: '<div> Account ID </div>',
//     valueKey: 'key',
//     textKey: 'value',
//     // maxLength: 7,
//     // maxLengthMessage: 'maximum 7 characters allowed.',
//   },country: {
//     key: 'country',
//     label: 'Country',
//     placeholder: '',
//     required: true,
//     requiredMessage: 'This field is required.',
//     displayLayout: 'col-md-12',
//     tooltip: '<div> Country </div>',
//     valueKey: 'key',
//     textKey: 'value',
//     // maxLength: 7,
//     // maxLengthMessage: 'maximum 7 characters allowed.',
//   },
//   isActive: {
//     key: 'isActive',
//     label: 'Status',
//     placeholder: '',
//     required: true,
//     requiredMessage: 'This field is required.',
//     displayLayout: 'col-md-12',
//     tooltip: '<div>  Status </div>',
//     options: [
//       { id: 1, key: 'status', value: "Active" },
//       { id: 0, key: 'status', value: "Inactive" },
//     ],
//     valueKey: 'id',
//     textKey: 'value',
//     // maxLength: 7,
//     // maxLengthMessage: 'maximum 7 characters allowed.',
//   },
//   credit: {
//     key: 'credit',
//     type: 'number',
//     label: 'Add Credit',
//     required: true,
//     placeholder: '',
//     requiredMessage: 'This field is required.',
//     displayLayout: 'col-md-12',
//     tooltip: '<div> Tenant Name </div>',
//     maxLength: 100,
//     maxLengthMessage: 'maximum 100 characters allowed.',
//     // pattern: /^(?=.*?[A-Za-z]).{1,}$/,
//     spaceNotAllowed: true
//   },
// };
// export const options = {
//   columns: [
//     // { id: 1, name: 's.no', label: 'S.No.', sortable: false, type: 'number' },
//     { id: 1, name: 'email', label: 'Email', sortable: true, type: 'number' },
//     { id: 2, name: 'name', label: 'Name', sortable: true, type: 'string' },
//     {
//       id: 3, name: 'contact', label: 'Phone', sortable: true, type: 'string',
//     },
//     {
//       id: 4, name: 'roleTenantList', label: 'Role', sortable: true, type: 'string',
//       component: (row) =>
//       (<div> {row.roleTenantList && row.roleTenantList.length ? row.roleTenantList.map((a, i) => <div key={a.roleId}>{a.roleName}</div>) : ''}</div>)
//     },{
//       id: 5, name: 'isActive', label: 'Status', sortable: true, type: 'string',component: (row) =>
//       (<div> {(row.roleTenantList[0].isActive == 1)? <p className='badge badge-success'>Active</p> : <p className='badge badge-danger'>Inactive</p> }</div>)
//     }



//   ],
//   keyCol: 'aId',
//   actions: [{
//     type: 'edit',
//     text: '',
//     icon: 'mdi mdi-pencil',
//     tooltip: 'Edit'
//   }
//   ],
//   recActive: true,
//   status: {
//     key: 'isActive',
//     active: '1',
//     activeIcon: 'mdi mdi-checkbox-marked',
//     inActiveIcon: 'mdi mdi-close-box',
//     confirmation: true,
//     activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
//     inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
//   },
//   actionsThead: false,
//   sortable: false,
//   dateType: true,
//   defaultSortParams: {
//     sortBy: 'BaseCurrency',
//     sortOrder: 'desc'
//   },
//   showSearch: false,
//   searchable: true,
//   searchColumns: [
//     { key: 'AlternateCurrency' }
//   ],
//   paging: true,
//   defaultPagingParams: {
//     pageSize: 25
//   }
// }
export const confirmationMessage = {
  action: {
    confirmationMessage: `Kindly let us know if you'd like to save your changes.`,
    type: 'Confirmation'
  }
}

export const successfullyMessage = {
  action: {
    confirmationMessage: 'Successfully Saved Tenant',
    type: 'alert',
  }
}
export const statusOptions = [
  { id: 1, value: 'Active' },
  { id: 0, value: 'Inactive' }
];

export const formFields = {
  agency: {
    key: 'agency',
    label: 'Agency',
    placeholder: '--Select--',
    displayLayout: 'col-md-12',
    required: false,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },
  advertiserName: {
    key: 'advertiserName',
    type: 'text',
    label: 'Advertiser Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    // labelLayout: 'col-md-12',
    tooltip: '<div> Campaign Plan Name </div>',
    // spaceNotAllowed: true
    // pattern: /^([a-zA-Z0-9&._@]+\s)*[a-zA-Z0-9&._@]$/,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Campaign Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
  },
  accountType: {
    key: 'accountType',
    label: 'Account Type',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'key',
    textKey: 'value',
  },
  status: {
    key: 'status',
    label: 'Status ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'value',
    options: [
      { id: 1, key: 'status', value: "Active" },
      { id: 0, key: 'status', value: "Inactive" },
    ],
  },
  addCredit: {
    key: 'addCredit',
    type: 'number',
    label: 'Credit-Line Status',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    // minLength: 3,
    // minLengthMessage: 'Minimum 3 charactors allowed.',
    // maxLength: 100,
    // maxLengthMessage: 'maximum 100 characters allowed.',
    displayLayout: 'col-md-12',
    // labelLayout:'py-1',
    tooltip: '<div> IO Name </div>',
    // spaceNotAllowed: true,
    // pattern: /^[A-Za-z_-][A-Za-z0-9_-]*$/,
    // patternMessage: 'Goal Name must start with a letter. Allowed characters are a-z & A-Z, 0-9,_,-'
    // pattern: /^(?=.*?[A-Za-z]).{1,}$/
  },
  accountOwnerName: {
    key: 'accountOwnerName',
    type: 'text',
    label: 'Account Owner Name',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Account Owner Name </div>',
  },
  accountOwnerEmail: {
    key: 'accountOwnerEmail',
    type: 'text',
    label: 'Account Owner Email',
    placeholder: '',
    required: true,
    requiredMessage: 'This field is required.',
    minLength: 3,
    minLengthMessage: 'Minimum 3 character allowed.',
    maxLength: 100,
    maxLengthMessage: 'Maximum 100 character allowed.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Account Owner Name </div>',
    pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/
  },
};

export const options = {
  columns: [
    { id: 1, name: '', label: '', sortable: false, },
    { id: 2, name: 'name', label: 'NAME', sortable: false, type: 'string' },
    { id: 3, name: 'email', label: 'EMAIL ID', sortable: true, type: 'number' },
    {
      id: 4, name: 'contact', label: 'PHONE NUMBER', sortable: true, type: 'string',
    },
    {
      id: 5, name: 'roleTenantList', label: 'ROLE', sortable: true, type: 'string',
      component: (row) =>
        (<div> {row.roleTenantList && row.roleTenantList.length ? row.roleTenantList.map((a, i) => <div key={a.roleId}>{a.roleName}</div>) : ''}</div>)
    },
    // { id: 6, name: '', label: 'SUB ACCOUNT ACCESS', sortable: true, type: 'string' },
    { id: 7, name: 'status', label: 'STATUS', sortable: true, type: 'string', component: (row) => row.isRecActive == 1 ? <p className='badge bg-label-success'>Active</p> : <p className='badge bg-label-danger'>Inactive</p> },
  ],
  keyCol: 'aId',
  actions: [
    // {
    //   type: 'status',
    //   text: '',
    //   icon: 'ti ti-toggle-left color-beki',
    //   tooltip: 'View Campign',
    //   iconType: 'new'
    // },
  ],
  recActive: true,
  status: {
    key: 'isRecActive',
    active: '1',
    activeIcon: 'mdi mdi-checkbox-marked',
    inActiveIcon: 'mdi mdi-close-box',
    confirmation: true,
    activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
    inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  },
  actionsThead: false,
  sortable: false,
  dateType: true,
  defaultSortParams: {
    sortBy: 'BaseCurrency',
    sortOrder: 'desc'
  },
  showSearch: false,
  searchable: true,
  searchColumns: [
    { key: 'AlternateCurrency' }
  ],
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
}